import PropTypes from 'prop-types';
import clsx from 'clsx';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';
import { useAlbumContext, PREVIOUS_STEP } from '@/utils/hooks/context/useAlbumContext';

// Components
import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';
import useTranslation from 'next-translate/useTranslation';
import DeleteAlbumModal from '@/components/pages/albums/DeleteAlbumModal';

const FooterModal = ({
    disableSubmitButton = false,
    submitStatus = {},
    submitAlbum = () => {
        /** */
    }
}) => {
    const { isOpen: isOpenDeleteModal, toggle: toggleDeleteModal } = useToggle();
    const { t } = useTranslation();
    const { albumInfo, dispatch } = useAlbumContext();

    return (
        <Modal.Footer
            className={clsx('flex items-center px-5 pb-12 pt-8 sm:px-12', {
                'justify-between': !albumInfo?.id,
                'justify-end gap-3': albumInfo?.id
            })}>
            {!albumInfo?.id ? (
                <button
                    onClick={() => dispatch({ type: PREVIOUS_STEP })}
                    disabled={submitStatus?.isSubmitting}
                    className="font-GMedium text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                    {t('commons:back')}
                </button>
            ) : (
                <Button
                    variant="secondary"
                    className="w-48"
                    disabled={submitStatus?.isSubmitting}
                    onClick={toggleDeleteModal}>
                    {t('content:modal.edit_modal.delete')}
                </Button>
            )}
            <Button
                className="w-48"
                disabled={disableSubmitButton}
                isLoading={submitStatus?.isSubmitting}
                onClick={submitAlbum}>
                {albumInfo?.id
                    ? t('content:modal.edit_modal.edit')
                    : t('content:modal.create_modal.create_album')}
            </Button>
            <DeleteAlbumModal
                isOpen={isOpenDeleteModal}
                toggle={toggleDeleteModal}
                albumId={albumInfo?.id}
            />
        </Modal.Footer>
    );
};

FooterModal.propTypes = {
    disableSubmitButton: PropTypes.bool,
    submitStatus: PropTypes.object.isRequired,
    submitAlbum: PropTypes.func.isRequired
};

export default FooterModal;
